<template>
  <div class="newMediaData">
    <template v-if="from!='introDetail'">
      <div id="block"></div>
      <Header />
      <Box1 />
    </template>
    <Box2 />
    <Box3 />
    <Box4 />
    <Box5 />
    <Box6 />
    <Box7 />
    <Box8 />
    <Box9 />
    <Box10 />
    <Box11 />
    <Box12 />
    <Box13 />

    <Footer />
    <pageRightFloat pageName="新媒体+短视频-就业课"/>
  </div>
</template>

<script>
import Box1 from "./Box1.vue";
import Box2 from "./Box2.vue";
import Box3 from "./Box3.vue";
import Box4 from "./Box4.vue";
import Box5 from "./Box5.vue";
import Box6 from "./Box6.vue";
import Box7 from "./Box7.vue";
import Box8 from "./Box8.vue";
import Box9 from "./Box9.vue";
import Box10 from "./Box10.vue";
import Box11 from "./Box11.vue";
import Box12 from "./Box12.vue";
import Box13 from "./Box13.vue";

import pageRightFloat from "../common/pageRightFloat.vue";
import Header from "../common/Header.vue";
import Footer from "../common/Footer.vue";
export default {
  components: {
    Box1,
    Box2,
    Box3,
    Box4,
    Box5,
    Box6,
    Box7,
    Box8,
    Box9,
    Box10,
    Box11,
    Box12,
    Box13,

    Header,
    Footer,
    pageRightFloat,
  },
  data() {
    return {
      from:''
    };
  },
  mounted() {
   this.from=this.getQueryString("from")
  },
};
</script>

<style lang="less" scoped>
#block {
  width: 100%;
  height: 88px;
}
</style>
